import { amplitudeTracker } from '../lib/shared/amplitude-tracker';
import { isIOS, isInApp } from '../lib/shared/user-agent-helpers';

function useExternalLink(pathname, query = '') {
    const urlWithoutProtocol = `powerplay.gg/${pathname}${window.location.search || '?'}${window.location.search ? '&' : ''}deviceId=${amplitudeTracker.getDeviceId()}${query ? `&${query}` : ''}`;
    const url = `https://${urlWithoutProtocol}`;

    const onClick = e => {
        if (isInApp()) {
            e.stopPropagation();
            e.preventDefault();

            if (isIOS()) {
                window.location.href = `googlechrome://${urlWithoutProtocol}`;
            } else {
                window.location.href = `googlechrome://navigate?url=${url}`;
            }

            setTimeout(() => {
                window.location.href = url;
            }, 250);
        };
    };

    return {
        url,
        onClick
    }
};

export {
    useExternalLink
};
